import { Coupon } from '@shared/interfaces/Coupon'
import { Plan } from '@shared/interfaces/Plan'

export function calculate( coupon: Coupon, plan: Plan, shippingFee: number ): number {
  if ( coupon.isRecommendation ) {
    return coupon.discount
  }

  const [ benefit ] = coupon.benefits

  if ( !benefit || !benefit.tipo_desconto ) {
    return 0
  }

  switch ( benefit.tipo_desconto.codigo ) {
    case 'KIT': {
      return benefit.percentual ? plan.valor_por_kit * fromPercent( benefit.valor ) : benefit.valor
    }
    case 'FRETE': {
      return benefit.percentual
        ? shippingFee * fromPercent( benefit.valor )
        : Math.min( benefit.valor, getTotalShippingFee( shippingFee, plan ) )
    }
    case 'FRETE_1_KIT': {
      const discount = benefit.percentual ? shippingFee * fromPercent( benefit.valor ) : benefit.valor
      return Math.min( discount, shippingFee )
    }
    case 'FRETE_TODOS': {
      const discount = benefit.percentual ? shippingFee * fromPercent( benefit.valor ) : benefit.valor
      return getTotalShippingFee( Math.min( discount, shippingFee ), plan )
    }
    case 'TOTAL': {
      if ( benefit.percentual ) {
        // TODO: Implementando apenas valor fixo por ser urgente.
        // eslint-disable-next-line no-console
        console.log( 'Não implementado' )

        return 0
      }

      return benefit.valor
    }
    default: {
      return 0
    }
  }
}

function fromPercent( value: number ): number {
  return value / 100
}

function getTotalShippingFee( fee: number, plan: Plan ) {
  return plan.tipo_plano === 'Anual' ? ( 12 * fee ) : fee
}
